import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import SnackBar from "../../components/SnackBar";
import { reprocessarSumarizacaoApuracao } from "../../services/apuracao.service";
import { exibirCodRelatorio, fmtMesAno } from "./utils";
import { formatValue } from "../../utils/formatValue";
import TermosExclusaoField from "./components/TermosExclusaoField";
import { extrairTermosExclusao } from "./Detalhe/utils/formatarFiltrosExclusao.util";
import styles from "./styles.module.css";

const ModalReprocessarSumarizacao = ({
  open,
  onClose,
  onSuccess,
  onError,
  apuracao = null,
  idApuracao,
}) => {
  const [termos, setTermos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });

  useEffect(() => {
    if (!open) {
      setObjSnackBar({ type: "", msg: "" });
      return;
    }
    setTermos(extrairTermosExclusao(apuracao?.sumarizacaoFiltros));
    setObjSnackBar({ type: "", msg: "" });
  }, [open, apuracao]);

  const handleClose = () => {
    if (loading) return;
    onClose?.();
  };

  const handleConfirmar = async () => {
    if (!idApuracao) return;
    setLoading(true);
    try {
      const res = await reprocessarSumarizacaoApuracao(idApuracao, {
        termos_exclusao: termos,
      });
      if (res?.sucesso) {
        onSuccess?.(res.mensagem || "Reprocessamento enfileirado.");
        handleClose();
      } else {
        const msg = res?.mensagem || "Não foi possível reprocessar a sumarização.";
        onError?.(msg);
        setObjSnackBar({ type: "error", msg });
      }
    } catch (e) {
      const msg = e?.message || "Erro ao solicitar reprocessamento.";
      onError?.(msg);
      setObjSnackBar({ type: "error", msg });
    } finally {
      setLoading(false);
    }
  };

  const cnpjFmt = formatValue("cnpj", apuracao?.cnpj);
  const empresa = apuracao?.empresa || "—";
  const tipo = exibirCodRelatorio(apuracao?.tipo);
  const periodo = `${fmtMesAno(apuracao?.periodoInicio)} – ${fmtMesAno(apuracao?.periodoFim)}`;

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>
          <div className={styles.title}>
            <RefreshIcon sx={{ marginRight: ".5rem" }} />
            Reprocessar sumarização
          </div>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div className={styles.readonlyBlock}>
            <span className={styles.readonlyLabel}>CNPJ — empresa</span>
            <Typography className={styles.readonlyValue}>
              {cnpjFmt} — {empresa}
            </Typography>
          </div>
          <div className={styles.readonlyBlock}>
            <span className={styles.readonlyLabel}>Tipo de apuração</span>
            <Typography className={styles.readonlyValue}>{tipo}</Typography>
          </div>
          <div className={styles.readonlyBlock}>
            <span className={styles.readonlyLabel}>Período de apuração</span>
            <Typography className={styles.readonlyValue}>{periodo}</Typography>
          </div>

          <Alert severity="info" sx={{ width: "100%" }}>
            Os termos informados <strong>substituem</strong> os filtros anteriores. Apenas a
            sumarização desta apuração será recalculada, com as mesmas contas — os valores
            mudam, mas as marcações de compõe projeto são preservadas.
          </Alert>

          <div className={styles.field}>
            <TermosExclusaoField
              termos={termos}
              onChange={setTermos}
              disabled={loading}
            />
          </div>
        </DialogContent>

        <DialogActions className={styles.containerBtn}>
          <Button
            onClick={handleClose}
            variant="contained"
            className={styles.btnCancelar}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmar}
            variant="contained"
            className={styles.btnSalvar}
            disabled={loading}
          >
            {loading ? "Enfileirando…" : "Reprocessar"}
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={setObjSnackBar} />
    </>
  );
};

export default ModalReprocessarSumarizacao;
